import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { ContainerApi } from "../../apis/api/DataApi";
import { CountryList } from "../../apis/api/CountryList";
import {AirportMaster,CommudityMaster,IMOMaster,UNMaster,} from "../../apis/api/DataApi";
import { insertFreightRequest } from "../../apis/api/FreightRerquestApi";
import Lodderr from "../Lodder/Lodder";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";

const New_Request = () => {
  const dispatch = useDispatch();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedIMO, setSelectedIMO] = useState(null);
  const [visible, setVisible] = useState(false);
  const onViewClick = (event) => {
    setVisible(event.target.checked);
  };
  const handleChange = (selectedOption) => {
    setSelectedCountry(selectedOption);

  };
  const handleIMOChange = (selectedOption) => {
    setSelectedIMO(selectedOption);

  };
  const {register,handleSubmit,reset,control,field,formState: { errors },} = useForm();

  const navigate = useNavigate();

  const [selectedOption, setSelectedOption] = useState(null);
  const [portmasteroption,setPortmasteroption] = useState();
  const handleSelectChange = (selected) => {
    setSelectedOption(selected?.value || "");
  };

  const transport = [
    { value: "lcl", label: "LCL" },
    { value: "fcl", label: "FCL" },
    { value: "air_freight", label: "Air Freight" },
  ];

  const shipping = [
    { value: "FOB", label: "FOB" },
    { value: "FCA", label: "FCA" },
    { value: "EX_WORKS", label: "EX_WORKS" },
  ];

  useEffect(() => {
    (async () => {
      dispatch(ContainerApi());
      dispatch(CountryList());
      dispatch(AirportMaster());
      dispatch(CommudityMaster());
      dispatch(IMOMaster());
      dispatch(UNMaster());
    })();
  }, []);

  const { containerlist } = useSelector((state) => state.DataSlice);
  const { country } = useSelector((state) => state.countrySlice);
  const { airportMaster,portMaster, commudityMaster, imoMaster, unMaster } = useSelector(
    (state) => state.DataSlice
  );

  console.log(portMaster,"portMaster");
  useEffect(() => {
    if (!selectedOption || !selectedCountry) return;
  
    const countryId = selectedCountry?.value.split(":")[0];
  
    if (selectedOption == "air_freight") {
      console.log("air_freight cheked!!")
      const portmasteroption = airportMaster.filter(
        (airport) => airport.CountryId == countryId
      );
      setPortmasteroption(portmasteroption);
    } else {
      console.log("LCL and HCL cheked!!")
      const portmasteroption = portMaster.filter(
        (airport) => airport.CountryId == countryId
      );
      setPortmasteroption(portmasteroption);
    }
  }, [selectedOption, selectedCountry, airportMaster]);

  const unmasteroption = unMaster.filter((un) => {
    if (!selectedIMO || !selectedIMO.imoValue) return false;

    const imoIds = selectedIMO.imoValue.split(".")[1];

    return imoIds.includes(un.unId);
  });




  const onSubmit = async (data) => {
    const formData = new FormData();
    const userId = Cookies.get("userID");

    Object.keys(data).forEach((key) => {
      if (data[key]) {
        if (typeof data[key] === "object" && data[key] !== null) {
          formData.append(key, data[key].value || JSON.stringify(data[key]));
        } else {
          formData.append(key, data[key]);
        }
      }
    });

    formData.append("userId", userId);

    const response = await dispatch(insertFreightRequest(formData));
    console.log(response);
    if(response.payload.status=='success'){
      reset();
      navigate('/sent_request');
      toast.success(response.payload.message);
    } else if(response.payload.status=='error'){
      toast.success(response.payload.message); 
    }else{
      toast.success('error'); 
    }
  };
 
  const { loading } = useSelector((state) => state.FreightRequest)


  return (
    <>
      {loading && <Lodderr />}
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 m-auto">
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="form-submit"
                method="post"
                enctype="multipart/form-data"
              >
                <div className="card shadow-sm">
                  <div className="card-header">
                    <h5 className="card-title">New Request</h5>
                  </div>

                  <div className="card-body mx-2">
                    <div className="form-content">
                      <div className="col-md-12 mt-2">
                        <label className="form-label">
                          Transportation Module{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Controller
                          name="transportation"
                          control={control}
                          rules={{ required: "Please select transportation" }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={transport}

                              placeholder="Select Transportation Module"
                              classNamePrefix="react-select"
                              onChange={(value) => {
                                field.onChange(value);
                                handleSelectChange(value);
                              }}
                            />
                          )}
                        />
                        {errors.transportation && (
                          <p className="text-danger">
                            {errors.transportation.message}
                          </p>
                        )}
                      </div>
                      {selectedOption === "lcl" && (
                        <div className="form-container p-2">
                          <table className="col-md-12">
                            <tr>
                              <td>
                                <div className="form-group mr-3">
                                  <label>Volume (cbm)</label>
                                  <span className="text-danger">*</span>
                                  <input
                                    type="number"
                                    className="form-control"
                                    {...register("lcl_volume", {
                                      required: "Volume is required",
                                      min: {
                                        value: 1,
                                        message: "Volume must be greater than 0",
                                      },
                                    })}
                                  />
                                  {errors.lcl_volume && (
                                    <p className="text-danger">
                                      {errors.lcl_volume.message}
                                    </p>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="form-group mr-3">
                                  <label>Weight (kgs)</label>
                                  <span className="text-danger">*</span>
                                  <input
                                    type="number"
                                    className="form-control"
                                    {...register("lcl_weight", {
                                      required: "Weight is required",
                                      min: {
                                        value: 1,
                                        message: "Weight must be greater than 0",
                                      },
                                    })}
                                  />
                                  {errors.lcl_weight && (
                                    <p className="text-danger">
                                      {errors.lcl_weight.message}
                                    </p>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="form-group mr-3">
                                  <label>Dimensions (cm)</label>
                                  <span className="text-danger">*</span>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="length/width/height"
                                    {...register("lcl_dimensions", {
                                      required: "Dimensions are required",
                                    })}
                                  />
                                  {errors.lcl_dimensions && (
                                    <p className="text-danger">
                                      {errors.lcl_dimensions.message}
                                    </p>
                                  )}
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>
                      )}

                      {selectedOption === "fcl" && (
                        <div className="form-container p-2">
                          <table className="col-md-12">
                            <tr>
                              <td>
                                <div className="form-group mr-3">
                                  <label className="form-label">
                                    Container Type{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <Controller
                                    name="fcl_container_type"
                                    control={control}
                                    rules={{
                                      required: "Container Type is required",
                                    }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={containerlist}
                                        placeholder="Select Container Type"
                                        classNamePrefix="react-select"
                                      />
                                    )}
                                  />
                                  {errors.fcl_container_type && (
                                    <p className="text-danger">
                                      {errors.fcl_container_type.message}
                                    </p>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="form-group mr-3">
                                  <label>Container Quantity</label>
                                  <span className="text-danger">*</span>
                                  <input
                                    type="number"
                                    className="form-control"
                                    {...register("fcl_container_count", {
                                      required: "Container Quantity is required",
                                      min: {
                                        value: 1,
                                        message: "Quantity must be at least 1",
                                      },
                                    })}
                                  />
                                  {errors.fcl_container_count && (
                                    <p className="text-danger">
                                      {errors.fcl_container_count.message}
                                    </p>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="form-group mr-3">
                                  <label>Weight (kg - cargo only)</label>
                                  <span className="text-danger">*</span>
                                  <input
                                    type="number"
                                    className="form-control"
                                    {...register("fcl_container_weight", {
                                      required: "Weight is required",
                                      min: {
                                        value: 1,
                                        message: "Weight must be greater than 0",
                                      },
                                    })}
                                  />
                                  {errors.fcl_container_weight && (
                                    <p className="text-danger">
                                      {errors.fcl_container_weight.message}
                                    </p>
                                  )}
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>
                      )}
                      {selectedOption === "air_freight" && (
                        <div id="airFreightFields">
                          <div className="form-container p-2">
                            <table className="col-md-12">
                              <tbody>
                                <tr>
                                  <td>
                                    <div className="form-group mr-3">
                                      <label>CTNS/QTY</label>
                                      <span className="text-danger">*</span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register("air_freight_pcs", {
                                          required: "CTNS/QTY is required",
                                          pattern: {
                                            value: /^[0-9]+$/,
                                            message: "Only numbers are allowed",
                                          },
                                        })}
                                      />
                                      {errors.air_freight_pcs && (
                                        <span className="text-danger">
                                          {errors.air_freight_pcs.message}
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-group mr-3">
                                      <label>Gross Weight (kg)</label>
                                      <span className="text-danger">*</span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register("air_freight_kgs", {
                                          required: "Gross Weight is required",
                                          pattern: {
                                            value: /^[0-9]+(\.[0-9]+)?$/,
                                            message:
                                              "Enter a valid weight (numbers only)",
                                          },
                                        })}
                                      />
                                      {errors.air_freight_kgs && (
                                        <span className="text-danger">
                                          {errors.air_freight_kgs.message}
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="form-group mr-3">
                                      <label>Dimensions</label>
                                      <span className="text-danger">*</span>
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register("air_freight_cbm", {
                                          required: "Dimensions are required",
                                        })}
                                      />
                                      {errors.air_freight_cbm && (
                                        <span className="text-danger">
                                          {errors.air_freight_cbm.message}
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="card-header">
                    <h5 className="card-title">Origin</h5>
                  </div>
    
                  <div className="card-body mx-2">
                    <div className="form-content " data-limit="3">
                      <div className="form-container">
                        <div className="row">
                          <div className="col-md-6">
                            <label className="form-label">
                              Location <span className="text-danger">*</span>
                            </label>
                            <Controller
                              name="OriginLocationCountry"
                              control={control}
                              rules={{ required: "Location is required" }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={country}
                                  placeholder="Location"
                                  classNamePrefix="react-select"
                                  onChange={(selectedOption) => {
                                    field.onChange(selectedOption);
                                    handleChange(selectedOption);
                                  }}
                                />
                              )}
                            />
                            {errors.OriginLocationCountry && (
                              <p className="text-danger">
                                {errors.OriginLocationCountry.message}
                              </p>
                            )}
                          </div>

                          {/* POD Field */}
                          <div
                            className="col-md-6"
                            id="from_location"
                            data-route=""
                          >
                            <label className="form-label">
                              POL <span className="text-danger">*</span>
                            </label>
                            <Controller
                              name="POL"
                              control={control}
                              rules={{ required: "POL is required" }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={portmasteroption}
                                  placeholder="POL"
                                  classNamePrefix="react-select"
                                />
                              )}
                            />
                            {errors.POL && (
                              <p className="text-danger">{errors.POL.message}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-header">
                    <h5 className="card-title">Destination</h5>
                  </div>
    
              
                  <div className="card-body mx-2">
                    <div className="form-content " data-limit="3">
                      <div className="form-container">
                        <div className="row">
                          <div className="col-md-6">
                            <label className="form-label">
                              Location <span className="text-danger">*</span>
                            </label>
                            <Controller
                              name="LocationCountry"
                              control={control}
                              rules={{ required: "Location is required" }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={country}
                                  placeholder="Location"
                                  classNamePrefix="react-select"
                                  onChange={(selectedOption) => {
                                    field.onChange(selectedOption);
                                    handleChange(selectedOption);
                                  }}
                                />
                              )}
                            />
                            {errors.LocationCountry && (
                              <p className="text-danger">
                                {errors.LocationCountry.message}
                              </p>
                            )}
                          </div>

                          {/* POD Field */}
                          <div
                            className="col-md-6"
                            id="from_location"
                            data-route=""
                          >
                            <label className="form-label">
                              POD <span className="text-danger">*</span>
                            </label>
                            <Controller
                              name="POD"
                              control={control}
                              rules={{ required: "POD is required" }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={portmasteroption}
                                  placeholder="POD"
                                  classNamePrefix="react-select"
                                />
                              )}
                            />
                            {errors.POD && (
                              <p className="text-danger">{errors.POD.message}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>




                  <div className="card-header">
                    <h5 className="card-title">Shipping term</h5>
                  </div>
                  <div className="card-body mx-2">
                    <div className="form-content">
                      <div className="form-container">
                        <div className="form-group col-md-12 mt-3">
                          <label className="form-label">
                            Shipping term <span className="text-danger">*</span>
                          </label>
                          <Controller
                            name="shippingTerm"
                            control={control}
                            rules={{ required: "Shipping term is required" }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={shipping}
                                placeholder="Select Shipping Term"
                                classNamePrefix="react-select"
                                onChange={(selectedOption) =>
                                  field.onChange(selectedOption)
                                }
                              />
                            )}
                          />
                        </div>
                        {errors.shippingTerm && (
                          <p className="text-danger">
                            {errors.shippingTerm.message}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  <h5 className="mx-3">Commodity Details</h5>

                  <div className="card-body ">
                    <div className="form-content">
                      <div className="form-container">
                        <div className="form-group col-md-12">
                          <p>
                            All non-temperature-controlled cargo is now quoted
                            under the commodity "Dry cargo - Freight all kinds".
                            This includes dangerous and liquid goods that do not
                            require temperature control.
                          </p>
                          <label className="form-label">
                            Commodity <span className="text-danger">*</span>
                          </label>
                          <Controller
                            name="Commodity"
                            control={control}
                            rules={{ required: "Commodity is required" }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={commudityMaster}
                                placeholder="Select Commodity"
                                classNamePrefix="react-select"
                                onChange={(selectedOption) =>
                                  field.onChange(selectedOption)
                                }
                              />
                            )}
                          />
                          {errors.Commodity && (
                            <p className="text-danger">
                              {errors.Commodity.message}
                            </p>
                          )}

                          <div className="check-box form-check-block col-md-6 mt-2">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="dangerous_cargo_checkbox"
                              name="dangerous_cargo"
                              onChange={onViewClick}
                              value="1"
                            />

                            <label className="form-check-label mx-2 mb-1">
                              Dangerous cargo
                            </label>
                          </div>

                          {visible && (
                            <div className="imo_field " data-limit="3">
                              <div className="row mb-3">
                                <div className="col-md-6">
                                  <label className="form-label">
                                    IMO Classification{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <Controller
                                    name="IMO_classification"
                                    control={control}
                                    rules={{
                                      required: "IMO Classification is required",
                                    }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={imoMaster}
                                        placeholder="Select IMO Classification"
                                        classNamePrefix="react-select"
                                        onChange={(selectedOption) => {
                                          field.onChange(selectedOption);
                                          handleIMOChange(selectedOption);
                                        }}
                                        value={field.value}
                                      />
                                    )}
                                  />

                                </div>

                                <div className="col-md-6 mb-3">
                                  <label className="form-label">
                                    UN number (Optional){" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <Controller
                                    name="UN_number"
                                    control={control}
                                    rules={{ required: "UN number is required" }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={unmasteroption}
                                        placeholder="Select UN number (Optional)"
                                        classNamePrefix="react-select"
                                        onChange={(selectedOption) =>
                                          field.onChange(selectedOption)
                                        }
                                      />
                                    )}
                                  />
                                  {errors.UN_number && (
                                    <p className="text-danger">
                                      {errors.UN_number.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                          <hr></hr>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body ">
                    <div className="form-content">
                      <div className="form-container mb-1">
                        <h6 className="form-title">Issue date of Loading</h6>

                        <div className="form-group col-md-6">
                          <label>
                            Issue Date <span className="text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            placeholder="Please Enter POD"
                            {...register("issueDate", {
                              required: "The Date field is required.",
                            })}
                          />
                          {errors.issueDate && (
                            <p className="text-danger">
                              {errors.issueDate.message}
                            </p>
                          )}
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="form-content">
                      <div className="form-container">
                        <span className="form-title text-dark">Comment</span>
                        <hr></hr>
                        <div className="form-group col-md-12">
                          <textarea
                            className="form-control"
                            name="comment"
                            placeholder="Comment"
                            rows="3"
                            {...register("comment", {
                              required: "The comment field is required.",
                            })}
                          ></textarea>
                        </div>
                        {errors.comment && (
                          <p className="text-danger">{errors.comment.message}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="text-right">
                      <button
                        type="submit"
                        className="btn btn-primary float-end ripple"
                      >
                        <i className="fa-solid fa-check"></i> Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default New_Request;
